import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import BCMSTransistion from '../BCMSTransistion/main.jsx';
import "./styles.css"

export default function BCMSDisabledPrompt(props) {
    const [ state, setState ] = useState(false);
    const ref = React.createRef();

    // disableClick :: HTMLElement -> VOID
    // For the given element, bind an onclick to show the disabled prompt
    // then if the element has any children, then map over those and disable them
    const disableClick = element => {
        element.addEventListener("click", evt => {
            setState(true);

            evt.preventDefault();
            evt.stopPropagation();
        });

        if(element.hasChildNodes()) {
            for(const node of element.children) {
                disableClick(node);
            }
        }
    };

    // Using a useEffect to disable all children after everything has been loaded
    useEffect(() => {
        disableClick(ref.current);
        // Remove the wrapper div
        ref.current.replaceWith(...ref.current.childNodes); 
    });

    return (
        <>
            {
                state && ReactDOM.createPortal(
                    <BCMSTransistion
                        inactive={ props.className }
                        active={ props.className === undefined ? "show-disabled" : props.className + " show-disabled" }
                        controller={(get, set, elem) => {
                            // useEffect to make sure the element is loaded
                            useEffect(() => {
                                // When loaded start animation, after duration update state to false
                                set(true);
                                setTimeout(() => setState(false), 1900);
                            });
                        }}
                        duration="1900">
                            <div className="disabled-prompt">This Is Not Available For Demonstration</div>
                    </BCMSTransistion>,
                    document.querySelector("#root")
                )
            }

            <div ref={ ref }>
                { props.children }
            </div>
        </>
    );
}